import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  news: NewsItem;
  variant?: "default" | "compact";
  className?: string;
}

export default function NewsCard({ news, variant = "default", className = "" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/news/detail/${news.id}`}
        className={`group flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-primary-50/40 ${className}`}
      >
        <div className="h-[68px] w-[92px] shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={news.cover}
            alt={news.title}
            title={`${news.title} - 58动漫资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
            {news.title}
          </h3>
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
            <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
              {news.category}
            </span>
            <span>{news.date}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${news.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 ${className}`}
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={news.title}
          title={`${news.title} - 58动漫资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-background-50">
          {news.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {news.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{news.summary}</p>
        <div className="mt-auto flex items-center justify-between pt-1 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-xs" />
            {news.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line text-xs" />
            {news.source}
          </span>
        </div>
      </div>
    </Link>
  );
}